import React from "react";

import Header from "./header";
import Navbar from "./navbar";
import Banner from "./banner";
import FeaturedPosts from "./featured-posts";
import LatestPosts from "./latest-posts";
import Lifestyle from "./life-style";

import AdPage from "./AdPage";

const PCTemplate: React.FC = () => {
  return (
    <div>
      <Header />

      <Navbar />

      <Banner />

      <AdPage />

      <FeaturedPosts />

      <LatestPosts />

      <Lifestyle />
    </div>
  );
};

export default PCTemplate;
